// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"5336": "5083bc5218c4","6495": "a9b28c737317","6563": "c118f70d3cdb","7167": "52f82b6c4668","927": "f921d25b46de",}[chunkId] + ".css"
}